export default "__VITE_ASSET__9Xk8_Kfe__"